<template>
  <pdf-page>
    <template #extra>
      <img src="~@/assets/report/quarter/book.png" class="extra" alt />
    </template>
    <div class="main">
      <div class="text-row">
        <div class="text-col">{{ dataSource.studentName }}小朋友总共练习的回合数</div>
      </div>
      <div class="text-row">
        <div class="text-col">到达</div>
        <div class="text-col large highlight">{{ dataSource.totalRound }}</div>
        <div class="text-col">回合</div>
      </div>
      <div class="text-row">
        <div class="text-col">练习的素材量达</div>
        <div class="text-col large highlight">{{ dataSource.materialNum }}</div>
        <div class="text-col">个</div>
      </div>
      <div class="text-row" v-if="dataSource.qualifiedMaterialNum">
        <div class="text-col">其中达标的素材量为</div>
        <div class="text-col large highlight">{{ dataSource.qualifiedMaterialNum }}</div>
        <div class="text-col">个</div>
      </div>
    </div>
  </pdf-page>
</template>

<script>
import PdfPage from './PdfPage'
export default {
  components: {
    PdfPage,
  },
  props: {
    dataSource: {
      type: Object,
      default() {
        return {}
      },
    },
  },
}
</script>

<style lang="less" scoped>
.main {
  text-align: center;
  padding-top: 54px;
  line-height: 50px;
  letter-spacing: 2px;
  font-weight: 500;
  font-size: 36px;
}
.text {
  &-row {
    display: flex;
    align-items: flex-end;
    justify-content: center;
  }
  &-col:not(.large) {
    margin-bottom: 5px;
  }
}
.large {
  font-size: 50px;
  line-height: 70px;
  letter-spacing: 1px;
}
.highlight {
  color: #ff7a55;
}
.extra {
  position: absolute;
  width: 756px;
  bottom: 231px;
  left: 50%;
  transform: translateX(-50%);
}
</style>